@if (!file) {
  <file-uploader-dropzone
    [config]="config"
    [disabled]="disabled"
    [hasFile]="hasFile"
    data-test-id="fileUploaderDropzone"
  >
    <file-uploader-button
      [config]="config"
      [disabled]="disabled"
      data-test-id="fileUploaderButton"
    >
    </file-uploader-button>
  </file-uploader-dropzone>
  @if (errorMessage) {
    <p
      class="t-data t-error"
      [innerHTML]="errorMessage"
      data-test-id="fileUploaderErrorMessage"
    ></p>
  }
}

@if (file) {
  <div class="u-flex">
    <file-uploader-progress
      [error]="uploadErr"
      (closeClicked)="clearFile()"
      class="u-maxX file-upload-progress"
      [file]="file"
      [total]="total"
      [loaded]="loaded"
      data-test-id="fileUploadProgress"
    >
    </file-uploader-progress>
  </div>
}
